export const Mode = {
  PRO: 'PRO',
  ARENA_CASH: 'ARENA_CASH',
  ARENA_ESSENCE: 'ARENA_ESSENCE',
} as const;

export type Mode = (typeof Mode)[keyof typeof Mode];
